export default "__VITE_ASSET__dVNHzwpL__"